export default function ProfessionalPath() {
  const milestones = [
    {
      year: '2007',
      title: 'Первые продажи',
      desc: 'Начало карьеры в продажах. Работа с клиентами, первые сделки, понимание профессии изнутри — с холодного звонка до закрытия контракта.'
    },
    {
      year: '2010',
      title: 'Корпоративные продажи',
      desc: 'Переход в сектор B2B. Сложные циклы сделок, работа с ЛПР, многоуровневые переговоры. Формирование системного взгляда на процесс продаж.'
    },
    {
      year: '2010–2021',
      title: 'Профессиональные Правовые Системы',
      desc: '11 лет в крупной белорусской компании. Путь от менеджера по продажам до руководителя учебного центра. Создание системы корпоративного обучения с нуля.'
    },
    {
      year: '2015',
      title: 'Корпоративный тренер',
      desc: 'Разработка и проведение программ обучения для сотен сотрудников. Первые внешние проекты, формирование авторской методологии.'
    },
    {
      year: '2016',
      title: 'Руководитель отдела продаж (и корпоративный тренер)',
      desc: 'Управление командой, построение системы мотивации, контроль KPI, наставничество — и параллельное проведение тренингов. Понимание, с какими проблемами сталкиваются РОПы.'
    },
    {
      year: '2017',
      title: 'Руководитель Корпоративного Учебного Центра',
      desc: 'Создание и руководство учебным центром компании. Построение системы обучения с нуля, управление командой тренеров, разработка методологии.'
    },
    {
      year: '2021',
      title: 'Консалтинг',
      desc: 'Запуск собственной практики. Фокус на корпоративных проектах: диагностика, обучение, внедрение, сопровождение. Работа с компаниями из Беларуси, России, Казахстана и Израиля.'
    },
    {
      year: 'Сегодня',
      title: '100+ проектов, 4500+ участников',
      desc: 'Системная работа с бизнесом. Авторские методики, концепция «Культурология продаж». Постоянное развитие и новые вызовы.'
    }
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Мой профессиональный путь
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            От первых продаж до 100+ корпоративных проектов. Не теория — реальный опыт, который стоит за каждой программой.
          </p>
        </div>

        <div className="relative">
          {/* Center line - desktop only */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-teal-200 -translate-x-1/2"></div>

          <div className="space-y-0">
            {milestones.map((milestone, i) => {
              const isLeft = i % 2 === 0;
              return (
                <div key={i} className={`relative flex flex-col md:flex-row items-start gap-0 pb-10 md:pb-14 last:pb-0 ${isLeft ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                  {/* Year bubble on center line */}
                  <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 z-10 w-16 h-16 bg-teal-600 rounded-full items-center justify-center shadow-lg">
                    <span className="text-white text-xs font-bold text-center leading-tight">{milestone.year}</span>
                  </div>

                  {/* Mobile year badge */}
                  <div className="md:hidden flex items-center gap-3 mb-3">
                    <div className="w-16 h-10 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-white text-xs font-bold">{milestone.year}</span>
                    </div>
                    <div className="h-0.5 flex-1 bg-teal-200"></div>
                  </div>

                  {/* Content card */}
                  <div className={`w-full md:w-[calc(50%-3rem)] ${isLeft ? 'md:pr-16 md:text-right' : 'md:pl-16 md:text-left'}`}>
                    <div className="bg-white rounded-xl p-5 md:p-6 shadow-sm hover:shadow-md transition-shadow">
                      <h3 className="text-lg font-bold text-gray-900 mb-2">{milestone.title}</h3>
                      <p className="text-sm text-gray-600 leading-relaxed">{milestone.desc}</p>
                    </div>
                  </div>

                  {/* Spacer for opposite side on desktop */}
                  <div className="hidden md:block w-[calc(50%-3rem)]"></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}